import React, { useState } from "react";
import useProductOptionSteps from "../Hooks/useProductOptionSteps";
import useProductInfoModal from "../Hooks/useProductInfoModal";
import useAddProductToCart from "../Hooks/useAddProductToCart";
import useCustomQty from "../Hooks/useCustomQty";
import useExtraInfoModal from "../Hooks/useExtraInfoModal"

export const ProductOptionStepsContext = React.createContext();

const ProductOptionStepsProvider = ({ productName, productId, children, auth, productCategory, taal, defaultoptions }) => {
    const ProductOptionSteps = useProductOptionSteps(productId,defaultoptions);
    const [productComment, setProductComment] = useState("");
    const ProductModal = useProductInfoModal(productId);
    const ProductToCart = useAddProductToCart(ProductOptionSteps.sku, productComment, productName, productCategory, taal)
    const CustomQty = useCustomQty(ProductOptionSteps.sku, productId)

    const ExtraInfoModal = useExtraInfoModal();
    const value = {
        ...ProductOptionSteps,
        ...ProductModal,
        ...ProductToCart,
        ...CustomQty,
        ...ExtraInfoModal,
        productComment,
        setProductComment,
        auth: (auth ? true : false),
        productName,
    };

    return (
        <ProductOptionStepsContext.Provider value={value}>
            {children}
        </ProductOptionStepsContext.Provider>
    );
};

export default ProductOptionStepsProvider;
